import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

const Element = ({ x, y, onMouseDown }) => (
  <div
    onMouseDown={onMouseDown}
    style={{
      transform: `translate(${x}px, ${y}px)`,
      cursor: "ew-resize",
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 10,
      height: "100%"
    }}
  >
    <div
      className="box"
      style={{
        position: "absolute",
        width: "9px",
        height: "100%",
        left: "-4px"
      }}
    ></div>
  </div>
);

const Draggable = ({ position, onDrag }) => {
  const [state, setState] = useState({
    isDragging: false,
    clientX: 0,
    clientY: 0,
    deltaX: 0,
    deltaY: 0
  });

  // mouse move
  const handleMouseMove = useCallback(
    ({ clientX, clientY }) => {
      if (state.isDragging) {
        const deltaX = clientX - state.clientX;
        const deltaY = clientY - state.clientY;

        setState(prevState => ({
          ...prevState,
          deltaX,
          deltaY
        }));
        onDrag({ deltaX, deltaY });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.isDragging]
  );

  // mouse left click release
  const handleMouseUp = useCallback(() => {
    if (state.isDragging) {
      setState(prevState => ({
        ...prevState,
        isDragging: false
      }));
    }
  }, [state.isDragging]);

  // mouse left click hold
  const handleMouseDown = useCallback(({ clientX, clientY }) => {
    setState(prevState => ({
      ...prevState,
      isDragging: true,
      clientX,
      clientY,
      deltaX: 0,
      deltaY: 0
    }));
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);

  return (
    <Element
      isDragging={state.isDragging}
      onMouseDown={handleMouseDown}
      x={position.x}
      y={position.y}
    />
  );
};

Draggable.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  })
};

Draggable.defaultProps = {
  position: {
    x: 20,
    y: 20
  }
};

export default Draggable;
